// ゴーグル商品　色変更時にバリアント下の説明変更
const productColorBtn = document.querySelectorAll('.product-color__input');
productColorBtn.forEach(ele => {
  ele.addEventListener('click', () => {
    // 各項目取得
    const goggleLens = document.getElementById('goggleLens');
    const goggleCoating = document.getElementById('goggleCoating');
    const goggleFilterColor = document.getElementById('goggleFilterColor');
    const goggleWeatherConditions = document.getElementById('goggleWeatherConditions');
    const goggleCat = document.getElementById('goggleCat');
    const goggleVlt = document.getElementById('goggleVlt');

    // 各項目にデータ入れ込み
    if (goggleLens) {
      goggleLens.innerHTML = `レンズ: ${ele.dataset.lens}`;
    }
    if (goggleCoating) {
      goggleCoating.innerHTML = `コーティング: ${ele.dataset.coating}`;
    }
    if (goggleFilterColor) {
      goggleFilterColor.innerHTML = `フィルタの色:${ele.dataset.filterColor}`;
    }
    if (goggleWeatherConditions) {
      goggleWeatherConditions.innerHTML = `天候条件: ${ele.dataset.weatherConditions}`;
    }
    if (goggleCat) {
      goggleCat.innerHTML = `CAT: ${ele.dataset.cat}`;
    }
    if (goggleVlt) {
      goggleVlt.innerHTML = `VLT: ${ele.dataset.vlt}`;
    }
  });
});

